import * as React from "react";
import { ReactSpreadsheetImport } from "react-spreadsheet-import";

const ImportExcel = ({
  isOpen = false,
  onClose,
  fields,
  onSubmit,
  title = "",
}) => {
  const fieldExample = {
    // Visible in table header and when matching columns.
    label: "Name",
    // This is the key used for this field when we call onSubmit.
    key: "name",
    // Allows for better automatic column matching. Optional.
    alternateMatches: ["first name", "first"],
    // Used when editing and validating information.
    fieldType: {
      // There are 3 types - "input" / "checkbox" / "select".
      type: "input",
    },
    // Used in the first step to provide an example of what data is expected in this field. Optional.
    example: "Stephanie",
    // Can have multiple validations that are visible in Validation Step table.
    validations: [
      {
        // Can be "required" / "unique" / "regex"
        rule: "required",
        errorMessage: "Name is required",
        // There can be "info" / "warning" / "error" levels. Optional. Default "error".
        level: "error",
      },
    ],
  };

  return (
    <ReactSpreadsheetImport
      isOpen={isOpen}
      onClose={onClose}
      onSubmit={onSubmit}
      fields={fields}
      translations={{
        uploadStep: {
          title: "Ngarko " + title + "",
          manifestTitle:
            "Te dhena qe priten - te dhenat te tipit date formati: yyyy-mm-dd ose dd-mm-yyyy",
          manifestDescription:
            "Do të keni mundësinë të riemërtoni ose hiqni kolonat në hapat e ardhshëm ",
          dropzone: {
            title: "Ngarko .xlsx, .xls ose .csv file",
            buttonTitle: "Zgjidh file",
          },
        },
        selectHeaderStep: {
          title: "Zgjidhni rreshtin e kokës",
          nextButtonTitle: "Vazhdo",
          backButtonTitle: "Kthehu",
        },
        matchColumnsStep: {
          title: "Rregullo kolonat",
          nextButtonTitle: "Tjetra",
          backButtonTitle: "Kthehu",
          userTableTitle: "Tabela juaj",
          templateTitle: "Do te behet",
          selectPlaceholder: "Zgjidh...",
          // ignoredColumnText: string,
          subSelectPlaceholder: "Zgjidh...",
          matchDropdownTitle: "Lidh",
          unmatched: "Pa lidhura",
          duplicateColumnWarningTitle: "Një kolonë tjetër e zgjedhur",
          duplicateColumnWarningDescription: "Kolonat nuk mund të dublikohen",
        },
        validationStep: {
          title: "Verifikoni të dhënat",
          nextButtonTitle: "Konfirmo",
          backButtonTitle: "Kthehu",
          noRowsMessage: "Nuk ka te dhena qe kane gabime",
          // noRowsMessageWhenFiltered: "Nuk ka te dhena qe kane gabime",
          discardButtonTitle: "Hiq rreshtat e selektuar",
          filterSwitchTitle: "Trego vetëm rreshtat me gabime",
        },

        alerts: {
          confirmClose: {
            headerTitle: "Largohu nga Importi",
            bodyText: "Je i sigurt? Informacioni juaj aktual nuk do të ruhet.",
            cancelButtonTitle: "Anullo",
            exitButtonTitle: "Largohu",
          },
          submitIncomplete: {
            headerTitle: "Errors detected",
            bodyText:
              "There are still some rows that contain errors. Rows with errors will be ignored when submitting.",
            bodyTextSubmitForbidden:
              "There are still some rows containing errors.",
            cancelButtonTitle: "Cancel",
            finishButtonTitle: "Submit",
          },
          submitError: {
            title: "Error",
            defaultMessage: "An error occurred while submitting data",
          },
          unmatchedRequiredFields: {
            headerTitle: "Not all columns matched",
            bodyText:
              "There are required columns that are not matched or ignored. Do you want to continue?",
            listTitle: "Columns not matched:",
            cancelButtonTitle: "Cancel",
            continueButtonTitle: "Continue",
          },
          toast: {
            error: "Error",
          },
        },
      }}
    />
  );
};

export default ImportExcel;
